import { useEffect, useRef, useState } from 'react';
import { fetchModelEthnicityPresetsWithStaticFallback } from '@/pages/ipe/workbench/utils/systemModelEthnicityPresetCatalog';

/** 节点 13.1–13.4 / 14.1–14.4 / 16.5：手持 / 万物穿戴 — API 优先，故障时 stale 缓存 / 静态 assets */
export function useModelEthnicityPresets(featureCode, modelType, ethnicity) {
  const [presets, setPresets] = useState([]);
  const [source, setSource] = useState('empty');
  const [fallbackUsed, setFallbackUsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestSeqRef = useRef(0);

  useEffect(() => {
    const feature = String(featureCode || '').trim();
    const model = String(modelType || '').trim();
    const eth = String(ethnicity || '').trim();
    if (!feature || !model || !eth) {
      setPresets([]);
      setSource('empty');
      setFallbackUsed(false);
      setLoading(false);
      setError(null);
      return undefined;
    }

    const requestSeq = requestSeqRef.current + 1;
    requestSeqRef.current = requestSeq;

    setPresets([]);
    setSource('empty');
    setFallbackUsed(false);
    setLoading(true);
    setError(null);

    let cancelled = false;

    fetchModelEthnicityPresetsWithStaticFallback({ featureCode: feature, modelType: model, ethnicity: eth })
      .then((result) => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setPresets(Array.isArray(result?.presets) ? result.presets : []);
        setSource(result?.source || 'empty');
        setFallbackUsed(Boolean(result?.fallbackUsed));
        setError(null);
      })
      .catch((err) => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setPresets([]);
        setSource('empty');
        setFallbackUsed(false);
        setError(err);
      })
      .finally(() => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [featureCode, modelType, ethnicity]);

  return {
    presets,
    source,
    fallbackUsed,
    loading,
    error,
  };
}
